// @flow
import HeaderContainer from './Header.container';

export default HeaderContainer;
